import { InvalidateQueries } from '@mews/framework';
import { RepositoryRegistry, useRepositoryMutation } from '@mews-commander/data-access';

interface Params {
    invalidateQueries?: InvalidateQueries<RepositoryRegistry>;
}

export const usePolicyExceptionUpdate = ({ invalidateQueries }: Params = {}) =>
    useRepositoryMutation('paymentAndCancellationPolicies', 'update', {
        invalidateQueries: invalidateQueries || {
            rateGroups: ['getAll', 'getOverviewEntries'],
        },
    });
